import styled from '@emotion/styled';
import { colors, fonts } from '@modernanimal/common';
import { FilterSelections } from '@modernanimal/common/src/web/SmartBookingFlow/smartBookingFlow.helpers';

import { LocationPartsFragment } from '../__generated__/graphql';
import Fonts from '../fonts';

type Props = {
    appointmentFilters: FilterSelections,
    locations: LocationPartsFragment[],
    selectedLocation: LocationPartsFragment | null,
    selectLocation: (location: LocationPartsFragment)=> void,
};

const AppointmentHeader = (props: Props) => {
    const {
        appointmentFilters,
        locations,
        selectedLocation,
        selectLocation,
    } = props;

    const getLocationByName = (locationName: string) => locations.find((location) => location.name === locationName);

    const handleSelect = (locationName: string) => {
        const location = getLocationByName(locationName);

        const isSameLocation = !!(location && appointmentFilters.selectedLocationIds?.includes(location.id));
        if (location && !isSameLocation) {
            selectLocation(location);
        }
    };

    return (
        <HeaderContainer>
            <Fonts.Heading04>Select an appointment</Fonts.Heading04>
            <Fonts.Body>Choose Location:</Fonts.Body>

            <PillContainer>
                {locations
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((location) => (
                        <Pill
                            selected={location.name === selectedLocation?.name}
                            key={location.id}
                            onClick={() => handleSelect(location.name)}
                        >
                            <PillText selected={location.name === selectedLocation?.name}>{location.name}</PillText>
                        </Pill>
                    ))}
            </PillContainer>
        </HeaderContainer>
    );
};

export default AppointmentHeader;

const HeaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

const PillContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
`;

const Pill = styled.button<({ selected: boolean })>`
    display: flex;
    align-self: center;
    padding: 8px 16px;
    border-radius: 20px;
    background-color: ${({ selected }) => (selected ? colors.PERIWINKLE_4 : colors.GREY_7)};
    color: ${colors.GREY_1};
    border: 1px solid ${({ selected }) => (selected ? colors.PRIMARY_PERIWINKLE : colors.GREY_7)};
`;

const PillText = styled(Fonts.BodySmall) <{ selected: boolean }>`
    ${({ selected }) => (selected ? `
        font-family: ${fonts.baseMedium.fontFamily};
        color: ${colors.PRIMARY_PERIWINKLE};
    ` : `
        padding: 0 .5px;
    `)};
`;
